/** Duration and relative-time formatting (spec §9.19 "time blindness aids": relative AND absolute). */
export function fmtMinutes(min: number): string {
  const m = Math.round(min);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h} h ${r} min` : `${h} h`;
}

export function fmtElapsed(ms: number): string {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h
    ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`
    : `${m}:${String(sec).padStart(2, "0")}`;
}

export function fmtTime(iso: string, locale?: string): string {
  return new Date(iso).toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
}

export function fmtDate(iso: string, locale?: string): string {
  return new Date(iso).toLocaleDateString(locale, { weekday: "short", day: "numeric", month: "short" });
}

/** "in 40 min · 14:20" / "3 d ago · Mon 28 Sep" */
export function fmtRelativeAbsolute(
  iso: string,
  nowMs: number,
  locale: string,
  t: (k: string, o?: Record<string, unknown>) => string,
): string {
  const diffMin = Math.round((Date.parse(iso) - nowMs) / 60_000);
  const abs = Math.abs(diffMin);
  let rel: string;
  if (abs < 60) rel = t(diffMin >= 0 ? "time.inMinutes" : "time.minutesAgo", { n: abs });
  else if (abs < 60 * 36)
    rel = t(diffMin >= 0 ? "time.inHours" : "time.hoursAgo", { n: Math.round(abs / 60) });
  else rel = t(diffMin >= 0 ? "time.inDays" : "time.daysAgo", { n: Math.round(abs / 1440) });
  const sameDay = new Date(iso).toDateString() === new Date(nowMs).toDateString();
  return `${rel} · ${sameDay ? fmtTime(iso, locale) : fmtDate(iso, locale)}`;
}

export function round1(x: number): number {
  return Math.round(x * 10) / 10;
}
